import React from 'react';
const useUpdateElement = (props, element) => {
    var _a, _b;
    React.useEffect(() => {
        if (element && (props === null || props === void 0 ? void 0 : props.container)) {
            element.update({
                table: props.table,
            });
        }
    }, [props.table]);
    React.useEffect(() => {
        if (element && (props === null || props === void 0 ? void 0 : props.container)) {
            element.update({
                column: props.column,
            });
        }
    }, [props.column]);
    React.useEffect(() => {
        if (element && (props === null || props === void 0 ? void 0 : props.container)) {
            element.update({
                validations: props.validations,
            });
        }
    }, [props.validations]);
    React.useEffect(() => {
        if (element && (props === null || props === void 0 ? void 0 : props.container)) {
            element.update({
                label: props.label,
            });
        }
    }, [props.label]);
    React.useEffect(() => {
        if (element && (props === null || props === void 0 ? void 0 : props.container)) {
            element.update({
                placeholder: props.placeholder,
            });
        }
    }, [props.placeholder]);
    React.useEffect(() => {
        if (element && (props === null || props === void 0 ? void 0 : props.container)) {
            element.update(Object.assign({}, props.classes));
        }
    }, [props.classes]);
    React.useEffect(() => {
        if (element && (props === null || props === void 0 ? void 0 : props.container)) {
            element.update({
                skyflowID: props.skyflowID,
            });
        }
    }, [props.skyflowID]);
    React.useEffect(() => {
        var _a, _b, _c, _d;
        if (element && (props === null || props === void 0 ? void 0 : props.container) && ((_b = (_a = props.options) === null || _a === void 0 ? void 0 : _a.cardMetadata) === null || _b === void 0 ? void 0 : _b.scheme)) {
            element.update({
                cardMetadata: {
                    scheme: (_d = (_c = props.options) === null || _c === void 0 ? void 0 : _c.cardMetadata) === null || _d === void 0 ? void 0 : _d.scheme
                }
            });
        }
    }, [(_b = (_a = props.options) === null || _a === void 0 ? void 0 : _a.cardMetadata) === null || _b === void 0 ? void 0 : _b.scheme]);
};
export default useUpdateElement;
//# sourceMappingURL=index.js.map